import * as React from 'react';
import { observer } from 'mobx-react';
import { translate } from '@estee/elc-service';
import { BackgroundWhiteTheme } from '../../../theme/default-theme';
import styled from 'styled-components';
import { Breakpoints } from '@estee/elc-base-theme';
import { MobileSortingDropdown } from './MobileSortingDropdown';
import { SortingTypes } from '../../constants/SortingTypes';
import { MPP_SORT_BY, MPP_PRODUCT_SORTING_DROPDOWN } from '../../constants/DataTestIdAttributes';
import { classes } from '../../utils/Classes';
import { Desktop, Mobile } from '@estee/elc-layouts';
import { Dropdown } from '../lazy-dropdown/LazyDropdown';

export interface IProductSortingDropdownTranslations {
    priceLowToHigh: string;
    priceHighToLow: string;
    topRated: string;
    sortByLabel: string;
}

export interface IProductSortingDropdown {
    productSortingDropdownValue: string;
    className: string;
    translations?: IProductSortingDropdownTranslations;
    setProductSortingDropdownValue(inputName: string, value: string): void;
}

export interface IResponsive {
    children: React.ReactNode;
    minWidth?: number;
    maxWidth?: number;
}

const StyledDropdown = styled(Dropdown)`
    ${BackgroundWhiteTheme};
`;

export const ProductSortingDropdown = translate([
    'priceLowToHigh',
    'priceHighToLow',
    'topRated',
    'sortByLabel'
])(
    observer(function ProductSortingDropdown(props: IProductSortingDropdown) {
        const {
            priceLowToHigh,
            priceHighToLow,
            topRated,
            sortByLabel
        } = props.translations as IProductSortingDropdownTranslations;

        const optionsArray = [
            { label: sortByLabel, value: SortingTypes.SORT_BY_LABEL },
            { label: topRated, value: SortingTypes.SORT_TOP_RATED },
            { label: priceHighToLow, value: SortingTypes.SORT_PRICE_HIGH_TO_LOW },
            { label: priceLowToHigh, value: SortingTypes.SORT_PRICE_LOW_TO_HIGH }
        ];

        const orderByNameDropDownClassNames = classes('product-sorting-dropdown');

        return (
            <div className={props.className}>
                <Desktop minWidth={Breakpoints.desktop}>
                    {() => (
                        <StyledDropdown
                            dropdownDataTestId={MPP_SORT_BY}
                            options={optionsArray}
                            name="order"
                            dataTestId={MPP_PRODUCT_SORTING_DROPDOWN}
                            selectedValue={
                                props.productSortingDropdownValue
                                    ? props.productSortingDropdownValue
                                    : sortByLabel
                            }
                            onChange={props.setProductSortingDropdownValue}
                            className={orderByNameDropDownClassNames}
                        />
                    )}
                </Desktop>
                <Mobile maxWidth={Breakpoints.desktop - 1}>
                    {() => (
                        <MobileSortingDropdown
                            productSortingDropdownValue={props.productSortingDropdownValue}
                            setProductSortingDropdownValue={props.setProductSortingDropdownValue}
                            optionsArray={optionsArray}
                        />
                    )}
                </Mobile>
            </div>
        );
    })
);
